var map = {
	"./Address.png": 3494,
	"./FAQimg.png": 3337,
	"./Gall1.png": 7291,
	"./News1.png": 5824,
	"./News2.png": 5995,
	"./News3.png": 5490,
	"./aboutus1.png": 7152,
	"./aboutus2.png": 971,
	"./aboutuss.png": 6914,
	"./board1.png": 5061,
	"./callsupport.png": 5787,
	"./chatwithus.png": 5750,
	"./client1.png": 4312,
	"./client2.png": 6291,
	"./client3.png": 6458,
	"./client4.png": 4869,
	"./contactus.png": 2102,
	"./dolldo.png": 3920,
	"./donate.png": 5425,
	"./donate2.png": 2407,
	"./gall2.png": 1792,
	"./gall3.png": 7545,
	"./gall4.png": 8918,
	"./gall5.png": 4015,
	"./gall6.png": 5204,
	"./handsicon.png": 8691,
	"./hope.png": 3258,
	"./houseicon.png": 8769,
	"./image.png": 8897,
	"./missionicon.png": 7203,
	"./shakeicon.png": 7567,
	"./teamImage.png": 4740,
	"./twogirls.png": 7499,
	"./visionicon.png": 5363,
	"./volunteer1.png": 1519,
	"./yosa.png": 3936
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1771;